import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./InfraL1.module.css";

function InfraL1({ distrito }) {
  const [situacaoEstradas, setSituacaoEstradas] = useState(null);
  const [manutencaoEstradas, setManutencaoEstradas] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [situacaoEstradas, manutencaoEstradas] = await Promise.all([
          Api.getSituacaoEstradas(distrito),
          Api.getManutencaoEstradas(distrito),
        ]);
        setSituacaoEstradas(Functions.buildPieGraphParams2(situacaoEstradas));
        setManutencaoEstradas(Functions.buildSmallPieGraphParams(manutencaoEstradas));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);

  const mockupFunction = (value) => {
    value = value + 1;
  };
  return (
    <div className={styles.infraL1}>
      <div className={styles.smallPiegraph}>
        {situacaoEstradas && (
          <SmallPieGraph
            data={situacaoEstradas}
            text="SITUAÇÃO DAS ESTRADAS"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {manutencaoEstradas && (
          <SmallPieGraph
            data={manutencaoEstradas}
            text="MANUTENÇÃO DAS ESTRADAS"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>
    </div>
  );
}

export default InfraL1;
